<template>
  <div class="container relative flex flex-col w-full h-full overflow-hidden">
    <div class="header" />
    <div class="relative mt-4 w-full h-full overflow-y-auto">
      <div v-if="article._Resources?.length" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <resource-item
          v-for="resource in article._Resources"
          :key="resource.Id"
          type="card"
          class="cursor-pointer hover:bg-gray-100"
          :resource="resource"
          :actions="actions"
          @click="onResourceClick(resource)"
          @action-click="onResourceActionClick"
        />
      </div>
      <div v-else class="flex items-center justify-center col-start-1 col-end-12">
        <p>{{ t('general.emptyList') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { clone } from 'lodash-es'
import useArticleLocalDataUpdater from '../composables/articleLocalDataUpdater'
import ResourceItem from '@/shared/components/resources/ResourceItem.vue'
import type MyArticle from '@/models/myArticle'
import Resource from '@/models/resource'
import { useUserStore } from '@/store/userData'
import { useNotificationStore } from '@/store/notification'
import { updateResourcesStatus } from '@/api/t1/resource'
import type { UpdateResourcesStatusModel } from '@/api/t1/model/resourceModel'
import { useConfirmDialog } from '@/shared/composables/confirmDialog'
import appConfig from '@/services/appConfig'

const props = defineProps<{
  article: MyArticle
}>()

const { t } = useI18n()
const confirmDialog = useConfirmDialog()
const userStore = useUserStore()
const notificationStore = useNotificationStore()
const { refreshLocalArticlesData } = useArticleLocalDataUpdater()

const actions: string[] = ['Delete']

function onResourceClick(resource: Resource) {
  window.open(resource.ResourceUrl)
}

async function onResourceActionClick(resource: Resource, action: string) {
  if (userStore.activeCatalog) {
    if (action === 'Delete') {
      const resourceClone = clone(resource)
      await confirmDialog(t('general.alert'), t('resources.confirmDeteleResourcesMessage'), [], async () => {
        const requestObject: UpdateResourcesStatusModel = {
          ResourceId: resource.ResourceId,
          Status: 0,
        }
        await updateResourcesStatus(resource.CatalogCode, [requestObject]).then(async () => {
          resourceClone.Status = 0
          const newResource = new Resource(resource.CatalogCode, resourceClone)
          await appConfig.DB!.resources.bulkPut([newResource])
          await refreshLocalArticlesData(false, props.article.ModelId, props.article.Id)
          notificationStore.addNotification(({ message: t('resources.alerts.resourceDeletedSuccessfully'), type: 'Success' }))
        }).catch((e) => {
          console.error(e)
          notificationStore.addNotification(({ message: t('resources.alerts.resourceDeletionFailed'), type: 'Alert' }))
        })
      })
    }
  }
}
</script>
